import React from 'react';
import classNames from 'classnames';
import { ISeance } from 'src/types/seance';
import styles from './assets/seance-actions.module.scss';
interface Props {
    original: Partial<ISeance>;
    data: any;
    setData: any;
}

const SeanceActionsColumn: React.FunctionComponent<Props> = ({ original, data, setData }) => {
    const handleChange = (event: any) => {
        const idValue = data[`${original?.id}`];
        setData({
            ...data,
            [`${original?.id}`]: {
                ...idValue,
                externalRatePerHour: original?.externalRatePerHour,
                externalEvalHourlyRate: original?.externalEvalHourlyRate,
                internalRatePerHour: original?.internalRatePerHour,
                action: !idValue?.action,
            },
        });
    };
    const actionValue = data[`${original?.id}`]?.action;
    return (
        <div className={classNames(styles.actions)}>
            <input type="checkbox" checked={!!actionValue} onClick={(value) => handleChange(value)} />
        </div>
    );
};

export default SeanceActionsColumn;
